// @ts-strict

import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { DatePickerService } from '@app/core/services/date-picker/date-picker.service';
import { GraphFilterOption } from '@pages/statistics/shared/interfaces/statistics';

@Component({
  selector: 'app-graph-legend',
  templateUrl: './graph-legend.component.html',
  styleUrls: ['./graph-legend.component.scss']
})
export class GraphLegendComponent implements OnChanges {
  @Input() currentSelectedData: GraphFilterOption[] = [];
  @Input() compareMode = false;

  public currentPeriod = 'today';
  public comparePeriod = 'yesterday';

  constructor(private datePickerService: DatePickerService) {}

  ngOnChanges(): void {
    this.datePickerService.generalChoosedRange.subscribe((res: any) => {
      if (res !== '') {
        this.currentPeriod = res.selectedRange;
      }
    });
    this.datePickerService.compareChoosedRange.subscribe((res: any) => {
      if (res !== '') {
        this.comparePeriod = res.selectedRange;
      }
    });

    this.currentSelectedData = this.currentSelectedData.filter(item => !item.compare);
  }
}
